import { Box, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';

import { AREA_OPTIONS, MANAGER_SUB_AREAS } from '../constants';

interface AreaSelectorProps {
  area: string;
  subArea: string;
  onAreaChange: (val: string) => void;
  onSubAreaChange: (val: string) => void;
  disabled?: boolean;
}

export const AreaSelector: React.FC<AreaSelectorProps> = ({
  area,
  subArea,
  onAreaChange,
  onSubAreaChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
          Area
        </Typography>
        <Select
          size="small"
          fullWidth
          value={area}
          onChange={(e) => onAreaChange(e.target.value)}
          disabled={disabled}
          sx={{ fontSize: '0.85rem', height: 36 }}
          MenuProps={{
            sx: { zIndex: 10002 },
            PaperProps: { sx: { maxHeight: 260 } },
          }}
        >
          {AREA_OPTIONS.map((opt) => (
            <MenuItem key={opt} value={opt} sx={{ fontSize: '0.85rem' }}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {area === 'Manager' && (
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', display: 'block', mb: 0.5 }}>
            Tab
          </Typography>
          <Select
            size="small"
            fullWidth
            value={subArea}
            onChange={(e) => onSubAreaChange(e.target.value)}
            disabled={disabled}
            sx={{ fontSize: '0.85rem', height: 36 }}
            MenuProps={{
              sx: { zIndex: 10002 },
              PaperProps: { sx: { maxHeight: 260 } },
            }}
          >
            {MANAGER_SUB_AREAS.map((tab) => (
              <MenuItem key={tab} value={tab} sx={{ fontSize: '0.85rem' }}>
                {tab}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Box>
  );
};
